// extracted by mini-css-extract-plugin
export default {"top":"Message_top__PiidQ","center":"Message_center__uPRMP"};